import { createContext } from 'react';

export const DEFAULT_LANGUAGE = 'en';

const TranslationContext = createContext(null);

export { TranslationContext };
